<template>
  <b-modal
    v-model="showModal"
    centered
    ok-variant="primary"
    cancel-variant="bg-white"
    title="Default Organization"
    body-class="p-1"
    size="sm"
    :ok-disabled="!selectedId || savingDefaultOrganization"
    @ok="saveChanges"
  >
    <div
      v-if="fetchingOrganizations"
      class="text-center py-2"
    >
      <b-spinner />
    </div>
    <div v-else-if="organizations.length === 0">
      There are no organizations available.
    </div>
    <div
      v-else
      class="d-flex flex-column align-items-center"
    >
      <div
        v-for="organization in organizations"
        :key="organization.id"
        class="d-flex w-100 align-items-center option"
      >
        <div
          class="d-flex align-items-center"
          @click="organization.isDefault ? '' : (selectedId = organization.id)"
        >
          <select-button
            :selected="selectedId && organization.id === selectedId"
          />
          <span class="option-name">
            {{ organization.name }}
          </span>
        </div>
        <span
          v-if="organization.isDefault"
          class="text-xsm option-default-text text-secondary"
        >
          (Default)
        </span>
      </div>
      <a
        v-if="hasMore"
        class="d-flex align-items-center option text-sm text-primary cursor-pointer"
        @click="pageIndex = pageIndex + 1"
      >
        Load More
      </a>
    </div>
    <template #modal-ok>
      <div class="d-flex align-items-center">
        <span>
          Save Changes
        </span>
        <b-spinner
          v-if="savingDefaultOrganization"
          style="margin-left:5px;"
          small
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import helpers from '@/mixins/helpers'

export default {
  name: 'DefaultOrganization',
  mixins: [helpers],
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true,
    },
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      pageSize: 5,
      pageIndex: 0,
      organizations: [],
      fetchingOrganizations: false,
      selectedId: null,
      hasMore: false,
      savingDefaultOrganization: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.users.user
    },
  },
  watch: {
    value(val) {
      this.showModal = val
      if (val) {
        this.fetchOrganizations()
      } else {
        this.reset()
      }
    },
    showModal(val) {
      this.$emit('input', val)
    },
    pageIndex() {
      if (this.showModal) {
        this.fetchOrganizations()
      }
    },
  },
  created() {
    this.showModal = this.value
  },
  methods: {
    reset() {
      this.organizations = []
      this.selectedId = null
      this.pageIndex = 0
    },
    saveChanges(e) {
      e.preventDefault()
      this.savingDefaultOrganization = true
      this.$store
        .dispatch('users/updateUser', {
          defaultOrganizationId: this.selectedId,
          defaultProjectId: null,
        })
        .then(() => {
          this.successToast('Default organization set successfully')
          this.$emit('defaultSet')
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while setting default organization.')
        })
        .finally(() => {
          this.savingDefaultOrganization = false
        })
    },
    fetchOrganizations() {
      this.fetchingOrganizations = true
      this.$store
        .dispatch('organization/fetchOrganizations', {
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
          returnOnly: true,
        })
        .then(res => {
          this.organizations = [...this.organizations, ...res.data.result]
          this.hasMore = res.data.result.length >= this.pageSize
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while fetching organizations.')
        })
        .finally(() => {
          this.fetchingOrganizations = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/variables';
.option {
  margin-bottom: 5px;
}
.option-name {
  line-height: 1;
  margin-left: 5px;
  cursor: default;
}
.option-default-text {
  margin-left: 7px;
}
</style>
